// ================= 站点导航 =================
export const navItems = [
  { id: "overview", label: "预警概览" },
  { id: "riskTypes", label: "风险盘点" },
  { id: "redFlags", label: "危险信号" },
  { id: "guide", label: "避雷指南" },
  { id: "checklist", label: "自查清单" },
  { id: "faq", label: "常见问题" },
] as const;

export const brandName = "女神塌房预警站";

// ================= 顶部数据 =================
export const stats = [
  { num: "40+", label: "典型预警信号", sub: "覆盖性格、商务、过往三类维度" },
  { num: "6", label: "常见塌房类型", sub: "从人设到口碑的分型拆解" },
  { num: "9", label: "核心自查维度", sub: "快速对照，一眼锁定风险" },
  { num: "4", label: "避雷行动路径", sub: "从识别信号到守住心态" },
] as const;

// ================= 为什么关注 =================
export const introBlocks = [
  {
    title: "塌房不是突然发生的",
    text: "很多人觉得塌房是一夜之间的事，其实绝大多数争议爆发前，都留有长短不一的预警窗口。那些被忽略的措辞变化、异常的营业节奏、逐渐紧绷的团队话术，往往就是暴风雨到来前的前兆。学会捕捉这些信号，是保护自己情绪的第一步。",
  },
  {
    title: "投入越深，越需要提前设防",
    text: "追星和吃瓜本是放松，可一旦把真实的喜欢、时间甚至金钱倾注在一个人设上，风险也随之放大。提前建立理性边界不是扫兴，而是对自己负责。真正的清醒，是在喜欢时留一分观察，在风浪来时能从容离场。",
  },
] as const;

export const introHighlights = [
  "认营业人设，也认真实信号",
  "看台前光环，也看幕后细节",
  "吃瓜有度，消息先核实再传播",
  "喜欢保持距离，离开不必愧疚",
] as const;

// ================= 风险盘点 =================
export interface RiskType {
  icon: string;
  title: string;
  level: string;
  desc: string;
}
export const riskTypes: RiskType[] = [
  {
    icon: "ri-fire-line",
    title: "人设崩塌型",
    level: "高发",
    desc: "荧幕人设与真实言行长期反差。表现是「努力人设」配塌房级生活习惯、公益宣传与实际做派脱节，营业越用力，崩塌后落差越大。",
  },
  {
    icon: "ri-heart-line",
    title: "私德争议型",
    level: "中高",
    desc: "恋情、家庭与品行问题被曝光。常见于恋情处理失当、婚内暧昧、家庭伦理纠纷等，往往伴随聊天记录、行程佐证不断被扒，讨论热度居高不下。",
  },
  {
    icon: "ri-shield-check-line",
    title: "法律风险型",
    level: "致命",
    desc: "涉税、合约与司法问题。这类风险通常由权威渠道或正规机构通报，性质最为严肃，一经坐实基本是职业生涯的重大转折点，几乎没有回旋余地。",
  },
  {
    icon: "ri-chat-3-line",
    title: "言论翻车型",
    level: "中发",
    desc: "历史发言被重新考古。成名前随意的社交动态、采访片段、评论区回复都可能被截图放大，尤其涉及立场、价值观争议时，舆论极易迅速发酵。",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "商务失信型",
    level: "中发",
    desc: "带货翻车与代言争议。产品质量出问题、功效夸大被点名、品牌立场变动未及时表态，都可能从「钱包信任」层面引发大面积脱粉与抵制。",
  },
  {
    icon: "ri-radar-line",
    title: "复合口碑型",
    level: "需警惕",
    desc: "多条线索交织、整体口碑滑坡。单个小问题往往不算什么，但当营业敷衍、态度傲慢、粉丝关系恶化等信号叠加出现时，往往是结构性危机的前奏。",
  },
] as const;

// ================= 危险信号 =================
export interface RedFlagGroup {
  key: string;
  title: string;
  sub: string;
  items: { title: string; sig: string }[];
}
export const redFlagGroups: RedFlagGroup[] = [
  {
    key: "character",
    title: "性格与言行",
    sub: "通过公开言行、采访与社交动态观察的蛛丝马迹",
    items: [
      {
        title: "营业话术突然模板化",
        sig: "本来自如的表达变成背书式回应，连互动内容都与团队通稿高度雷同，说明人设正被刻意维护。",
      },
      {
        title: "言行前后明显矛盾",
        sig: "同一事件在不同场合给出相反说法，或公开承诺与后续行动严重不符，反差常是风险起点。",
      },
      {
        title: "情绪管理异常波动",
        sig: "在镜头前频繁失态、突然对粉丝或路人冷言冷语，可能预示承受压力的同时心态正在失衡。",
      },
      {
        title: "回应「过度解释」",
        sig: "面对小事反而长篇大论反复澄清、删删改改，越描越黑的背后，往往藏着不想被看见的部分。",
      },
    ],
  },
  {
    key: "business",
    title: "商务与合作",
    sub: "从代言、带货与资源变化中读出的风向信号",
    items: [
      {
        title: "品牌提前「切割」",
        sig: "商务物料悄然下架、官方账号清空合作内容、原定官宣无声取消，常是资本方先嗅到风险的强烈信号。",
      },
      {
        title: "带货口碑持续下滑",
        sig: "商品质量、售后与话术被反复吐槽仍不整改，说明对粉丝的信任与口碑积累并不真正上心。",
      },
      {
        title: "资源降级与行程骤减",
        sig: "曾经稳定的综艺、剧集与商务明显缩水，有时是行业内部消息外溢，未必只是「休息调整」。",
      },
      {
        title: "团队换血且口径不一",
        sig: "核心经纪与公关人员频繁变动，团队对外说法前后矛盾，往往意味着内部已出现裂痕与危机预案。",
      },
    ],
  },
  {
    key: "past",
    title: "过往与暗线",
    sub: "时间线考古与周边信息里容易被忽略的伏笔",
    items: [
      {
        title: "早期低门槛发言被存证",
        sig: "成名前的小号、评论区、旧采访正在被网友系统性整理，任何一条都可能在风口上被引爆。",
      },
      {
        title: "多人遭遇惊人一致",
        sig: "若不同时间、不同渠道的人给出指向同一倾向的零星描述，偶然性下降，可信度反而上升。",
      },
      {
        title: "绯闻与澄清反复拉锯",
        sig: "感情、合约问题隔段时间就被旧事重提，说明暗线从未真正平息，只待一个再次点火的时机。",
      },
      {
        title: "官方口径变得暧昧",
        sig: "对热门争议既不否认也不承认，用「给大家一点时间」式的模糊话术拖延，通常是危机正在酝酿的典型前兆。",
      },
    ],
  },
] as const;

// ================= 避雷指南 =================
export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  points: string[];
}
export const guideSteps: GuideStep[] = [
  {
    step: "01",
    title: "认准一手信源",
    desc: "吃瓜先看来源、再看转述。把「评论区传说」与「官方通报」「可靠媒体报道」区分开，是避免被带节奏的第一道防线。",
    points: [
      "优先官方通报与正规媒体",
      "警惕营销号与断章取义截图",
      "时间线对齐后再下判断",
    ],
  },
  {
    step: "02",
    title: "看信号，而非滤镜",
    desc: "把「我喜欢」和「客观事实」分开。对营业内容保持欣赏，对行为证据保持冷静，别让人设光环替你做判断。",
    points: [
      "区分人设包装与真实行为",
      "用信号清单而非情感做结论",
      "给负面证据同等的注意力",
    ],
  },
  {
    step: "03",
    title: "交叉验证再表态",
    desc: "情绪上头时最容易站错队。在转发、站队、下结论之前，先让多方信息互相印证，给事实留出沉淀的时间。",
    points: [
      "让子弹飞一会儿再评论",
      "不传播未经核实的截图",
      "明确区分事实与个人推断",
    ],
  },
  {
    step: "04",
    title: "守住情绪与金钱边界",
    desc: "无论结果如何，都别让一次塌房击穿你的生活。追星是生活的调味，不是全部，提前设限才能始终掌握主动权。",
    points: [
      "不借贷、不动用必需开销应援",
      "塌房不否定曾经的美好",
      "把时间和爱留给自己",
    ],
  },
] as const;

// ================= 自查清单 =================
export const checklistItems = [
  {
    title: "我已分得清「人设」与「真人」",
    desc: "明白看到的是营业作品，而非未经剪辑的完整人格。",
  },
  {
    title: "我知道她主要的公开争议史",
    desc: "对既往的言论与事件有基本了解，而非选择性忽略。",
  },
  {
    title: "我关注一手信源而非营销号",
    desc: "获取信息的渠道以官方、正规媒体与本人账号为主。",
  },
  {
    title: "遇到反转我会先求证",
    desc: "不因一张截图或一句标题就急着下结论、急着站队。",
  },
  {
    title: "我的投入在可承受范围内",
    desc: "应援、时间与情绪投入都不影响正常生活与财务健康。",
  },
  {
    title: "我不把偶像当作人生模板",
    desc: "欣赏作品与品格，但价值观与人生选择仍由自己决定。",
  },
  {
    title: "我愿意在必要时体面离场",
    desc: "若真相与个人原则冲突，能平静告别而不是自我消耗。",
  },
  {
    title: "我不传播未经证实的说法",
    desc: "吃瓜保留分寸，不对当事人作无证据的人身攻击。",
  },
] as const;

// ================= FAQ =================
export const faqs = [
  {
    q: "什么是「塌房」，为什么会叫塌房？",
    a: "「塌房」是网络用语，原指房子塌了，引申为一直支持的偶像、明星或公众人物因负面事件曝光，其人设与形象轰然倒塌。之所以用这个词，是因为粉丝投入的感情与信任就像住在一栋精心营造的「房」里，负面事实一旦证实，这栋房子的根基便不复存在。",
  },
  {
    q: "出现哪些信号就需要开始警惕？",
    a: "常见预警信号可以从性格言行、商务合作、过往经历三个维度观察，例如营业话术突然模板化、品牌提前切割、历史发言被集中考古、回应越描越黑等。这些信号单独出现未必代表一定塌房，但一旦多个信号叠加出现，风险就会明显上升。",
  },
  {
    q: "出现预警信号，就代表一定会塌房吗？",
    a: "不一定。预警信号本质上是一种「风险提示」，它帮助我们保持观察，而不是急着定罪。有的争议只是误会或会被妥善澄清，有的则可能持续发酵。理性的做法是把信号当作提醒，用事实和时间去验证，而不是被情绪推着提前站队。",
  },
  {
    q: "怎样才能避免投入过深、减少受伤？",
    a: "核心是把喜欢与生活分开：先确认自己投入的时间、情绪和金钱都在可承受范围内，只消费正面的作品与内容，不把人生选择寄托在偶像身上。当你始终保有独立的判断和清醒的边界，无论结果如何，都能从容面对。",
  },
  {
    q: "吃瓜时如何避免成为谣言的帮凶？",
    a: "吃瓜要留分寸：先确认信息源是否可靠，优先官方与正规媒体，警惕营销号和断章取义的截图；转发和评论前让信息交叉验证，别急着站队；明确区分事实与猜测，不传播未经证实的说法，也不对当事人作无依据的人身攻击。",
  },
] as const;

// ================= 关于与联系 =================
export const aboutValues = [
  {
    icon: "ri-focus-2-line",
    title: "客观盘点",
    desc: "只做风险类型与信号维度的系统梳理，不对任何真实人物下定论。",
  },
  {
    icon: "ri-eye-line",
    title: "理性吃瓜",
    desc: "倡导以证据与常识判断，而非情绪与流言驱动，拒绝网络暴力。",
  },
  {
    icon: "ri-shield-check-line",
    title: "自我保护",
    desc: "一切内容最终服务于「守住你的情绪与生活」，而非制造焦虑。",
  },
] as const;

export const contactEmail = "hello@nvshentafang.cn";